import {
  useContext
} from 'react';
import {
  GoogleTagManager8847Context,
  type GoogleTagManagerContext8847Type,
} from '../ui';

export const useGoogleTagManager8847 = (): Maybe<GoogleTagManagerContext8847Type> => {
  const context = useContext(GoogleTagManager8847Context);
  return context;
};